<template>
  <section class="compliance-section py-5">
    <div class="container">
      <div class="row align-items-center">
        <!-- Imagen del lado izquierdo -->
        <div class="col-lg-5 mb-4 mb-lg-0 d-flex justify-content-center">
          <!-- Sustituye la ruta por la imagen correcta -->
          <img src="@/assets/nom.webp" alt="Cumplimiento NOM-004-SSA3-2012" class="img-fluid compliance-image" />
        </div>
        <!-- Texto y lista de características -->
        <div class="col-lg-7">
          <h2 class="compliance-title mb-3">
            Cumplimiento Total con la <span class="highlight">NOM-004-SSA3-2012</span>
          </h2>
          <p class="compliance-desc mb-4">
            Medicynia está diseñado desde su núcleo para asegurar que tu práctica cumpla con la normativa mexicana.
          </p>
          <ul class="compliance-list mb-4">
            <li><i class="bi bi-check-circle-fill"></i> Generación de notas médicas con estructura adecuada y cierre oportuno.</li>
            <li><i class="bi bi-check-circle-fill"></i> Firma autógrafa digitalizada para respaldo legal.</li>
            <li><i class="bi bi-check-circle-fill"></i> Registro de cada consulta con trazabilidad completa.</li>
            <li><i class="bi bi-check-circle-fill"></i> Conservación de expedientes clínicos por mínimo 5 años.</li>
            <li><i class="bi bi-check-circle-fill"></i> Control de acceso al expediente (usuarios y bitácoras).</li>
            <li><i class="bi bi-check-circle-fill"></i> Identificación del profesional responsable en cada documento.</li>
            <li><i class="bi bi-check-circle-fill"></i> URLs temporales para descargas seguras con token y expiración.</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ComplianceSection',
}
</script>

<style scoped>
.compliance-section {
  background: linear-gradient(135deg, #1DE9B6 0%, #00BFA5 100%);
  color: #fff;
}
.compliance-title {
  font-size: 2.5rem;
  font-weight: 700;
  color: #212529;
}
.compliance-title .highlight {
  color: #ffffff;
  border-bottom: 4px solid #1DE9B6;
  padding-bottom: 2px;
}
.compliance-desc {
  font-size: 1.15rem;
  color: #f8f9fa;
}
.compliance-list {
  list-style: none;
  padding: 0;
}
.compliance-list li {
  display: flex;
  align-items: center;
  font-size: 1.08rem;
  margin-bottom: 0.7rem;
  color: #fff;
}
.compliance-list i {
  color: #161a18;
  font-size: 1.3rem;
  margin-right: 0.7rem;
}
.compliance-btn {
  border: 2px solid #fff;
  color: #00BFA5;
  background: #fff;
  font-weight: 600;
  border-radius: 8px;
  padding: 0.7rem 2.2rem;
  transition: background 0.2s, color 0.2s;
}
.compliance-btn:hover {
  background: #00BFA5;
  color: #fff;
  border-color: #fff;
}
.compliance-image {
  max-width: 350px;
  border-radius: 18px;
  box-shadow: 0 8px 32px rgba(0,0,0,0.13);
  background: #fff;
  padding: 0.5rem;
}
@media (max-width: 991.98px) {
  .compliance-title {
    font-size: 2rem;
  }
  .compliance-image {
    max-width: 250px;
  }
}
@media (max-width: 767.98px) {
  .compliance-section {
    padding: 2rem 0;
  }
  .compliance-title {
    font-size: 1.5rem;
  }
  .compliance-image {
    max-width: 180px;
    margin-bottom: 1.5rem;
  }
}
</style>
